const PageStatus = ({status}) => {
    return (
        <div className={`page-status page-status--${status}`}>
            <span className="page-status__indicator"/>
        </div>
    );
};

export default PageStatus;